import React, { useContext } from 'react';
import type { IRowNode } from 'ag-grid-community';

import Cell from './V5Gadget/Matrix/Cell';
import isGeneralBoard from '../isBoardWithSlideOut';
import useIsGridLinksDisabled from '../hooks/useIsGridLinksDisabled';
import Row from './Common/Row';
import BoardSlideOutContext from '../contexts/BoardSlideOutContext';
import BoardContext from '../contexts/BoardContext';
import EntityLink from './V5Gadget/Matrix/GroupingCellRenderer/EntityLink';
import {
  FleetopsGridCellRendererParams,
  FleetOpsGridColDef,
} from '../types/agGrid';

const DrillDownCell = ({
  fieldValue,
  selectFieldValue,
  node,
  colDef,
}: {
  fieldValue: string;
  selectFieldValue: (fieldValue: string) => void;
  node: IRowNode<any>;
  colDef: FleetOpsGridColDef;
}) => {
  const isLinksDisabled = useIsGridLinksDisabled();
  const onClick = (event: any) => {
    event.stopPropagation();
    selectFieldValue(fieldValue);
    node.setSelected(true, true);
  };

  if (isLinksDisabled) {
    return (
      <Cell>
        <Row centerAlign>
          <span>{fieldValue}</span>
        </Row>
      </Cell>
    );
  }

  return (
    <Cell onClick={onClick} style={{ cursor: 'pointer' }}>
      <Row centerAlign spaceBetween>
        <span style={{ color: 'var(--color-text-link)' }}>{fieldValue}</span>
        <EntityLink colDef={colDef} value={fieldValue} node={node} />
      </Row>
    </Cell>
  );
};

const Gate = ({ value, node, colDef }: FleetopsGridCellRendererParams) => {
  const boardSlideOutContext = useContext(BoardSlideOutContext);
  const { board } = useContext(BoardContext);
  if (
    !boardSlideOutContext ||
    typeof value !== 'string' ||
    !board ||
    !isGeneralBoard(board)
  ) {
    if (Array.isArray(value)) {
      return (
        <Cell>
          <span>{value.join(', ')}</span>
        </Cell>
      );
    } else {
      return (
        <Cell>
          <Row spaceBetween centerAlign>
            <span>{value}</span>
          </Row>
        </Cell>
      );
    }
  }

  return (
    <DrillDownCell
      fieldValue={value as string}
      selectFieldValue={boardSlideOutContext.selectFieldValue}
      node={node}
      colDef={colDef}
    />
  );
};

export default Gate;
